import AppStore from "./app.store";
import { configure } from "mobx";

configure({
  enforceActions: "never",
});

export { AppStore };
